function debounce (timeout, fn) {
  let handle
  let args

  function execute () {
    fn.apply(null, args) // eslint-disable-line prefer-spread
  }

  function debounced () {
    args = arguments // eslint-disable-line prefer-rest-params
    clearTimeout(handle)
    handle = setTimeout(execute, timeout)
  }

  debounced.callNow = function () {
    clearTimeout(handle)
    execute()
  }

  debounced.cancel = function () {
    clearTimeout(handle)
  }

  return debounced
}

module.exports = debounce
